import * as React from "react";

const FooterAppIcon: React.FC = () => {
    return (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M28.7461 38H12.1451C10.9326 38 10 37.0674 10 35.8549V4.14508C10 2.93264 10.9326 2 12.1451 2H28.7461C29.9585 2 30.8912 2.93264 30.8912 4.14508V35.8549C30.8912 37.0674 29.9585 38 28.7461 38Z" stroke="#51D4D9" stroke-width="1.6" stroke-miterlimit="10" stroke-linecap="round" />
            <path d="M18.7666 33.8032H22.1241" stroke="#51D4D9" stroke-width="1.6" stroke-miterlimit="10" stroke-linecap="round" />
            <path d="M10.1865 29.2332H30.6114" stroke="#51D4D9" stroke-width="1.6" stroke-miterlimit="10" stroke-linecap="round" />
            <path d="M10.1865 7.50244H30.6114" stroke="#51D4D9" stroke-width="1.6" stroke-miterlimit="10" stroke-linecap="round" />
        </svg>
    );
};

export default React.memo(FooterAppIcon);
